import React from 'react';
import { Button } from './ui/button';
import { TrendingUp, Zap } from 'lucide-react';

/**
 * "Advanced Algorithms" section: intro copy on the left, feature cards on the right.
 */
const FeatureAdvancedAlgos = ({ t, pick }) => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
    <div className="grid md:grid-cols-2 gap-12 items-center">
      <div>
        <div className="inline-block px-4 py-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-6">
          <span className="text-cyan-400 text-sm font-semibold">{pick('advanced_badge')}</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">{pick('advanced_title')}</h2>
        <p className="text-lg text-white/70 mb-8">{pick('advanced_description')}</p>
        <Button size="lg" className="bg-white text-black hover:bg-white/90">
          {pick('advanced_cta')}
        </Button>
      </div>

      <div className="relative">
        <div className="bg-gradient-to-br from-cyan-500/10 to-blue-500/10 backdrop-blur-sm border border-white/10 rounded-2xl p-8 shadow-2xl">
          <div className="space-y-6">
            <FeatureRow
              iconWrap="bg-green-500/20"
              icon={<TrendingUp className="text-green-400" size={24} />}
              title={t.features.advancedAlgos.stockMarket}
              desc={t.features.advancedAlgos.stockMarketDesc}
            />
            <FeatureRow
              iconWrap="bg-orange-500/20"
              icon={
                <svg className="w-6 h-6 text-orange-400" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm1 5h-2v6h5v-2h-3V7z" />
                </svg>
              }
              title={t.features.advancedAlgos.bitcoinPrice}
              desc={t.features.advancedAlgos.bitcoinPriceDesc}
            />
            <FeatureRow
              iconWrap="bg-purple-500/20"
              icon={<Zap className="text-purple-400" size={24} />}
              title={t.features.advancedAlgos.realTime}
              desc={t.features.advancedAlgos.realTimeDesc}
            />
          </div>
        </div>
        <div className="absolute -inset-4 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-3xl -z-10"></div>
      </div>
    </div>
  </section>
);

const FeatureRow = ({ iconWrap, icon, title, desc }) => (
  <div className="flex items-center space-x-4">
    <div className={`w-12 h-12 ${iconWrap} rounded-lg flex items-center justify-center`}>{icon}</div>
    <div>
      <h4 className="text-white font-semibold">{title}</h4>
      <p className="text-white/60 text-sm">{desc}</p>
    </div>
  </div>
);

export default FeatureAdvancedAlgos;
